export default {
    RESISTANCE_COEF: 0.6,
  
    // This value is closed to what browsers are using internally to
    // trigger a native scroll.
    UNCERTAINTY_THRESHOLD: 3, // px
  };